export const objectWithoutKeys: <T>(obj: Record<string, T>, keys: string[]) => Record<string, T> = <T>(
  obj: Record<string, T>,
  keys: string[]
) => {
  const strKeys = keys.map((key) => key);
  const newObj: Record<string, T> = {};

  for (const key in obj) {
    if (strKeys.includes(key)) {
      continue;
    }
    newObj[key] = obj[key];
  }

  return newObj;
};
